import { useState, useCallback } from 'react';

function useClientRect() {
  const [rect, setRect] = useState<DOMRect | undefined>(undefined);
  const ref = useCallback((node: any) => {
    if (node) setRect(node.getBoundingClientRect());
  }, []);
  return [rect, ref] as [DOMRect | undefined, () => any];
}

export default useClientRect;
